import React, { useState, useCallback, useMemo } from 'react';
import api from 'services';

const RelTalhaoContext = React.createContext({});

export function RelTalhaoProvider({ children }) {
  const [relTalhaoProducao, setRelTalhaoProducao] = useState([]);
  const [relTalhaoProducaoLoading, setRelTalhaoProducaoLoading] =
    useState(false);

  const getTalhoesProducao = useCallback(async (filter) => {
    try {
      setRelTalhaoProducaoLoading(true);
      const newFilters = {
        fazenda: filter?.fazenda?.id,
        atividade: filter?.atividade?.id,
        dateStart: filter?.dateStart === '' ? undefined : filter?.dateStart,
        dateEnd: filter?.dateEnd === '' ? undefined : filter?.dateEnd,
        intervalo: filter?.intervalo === ' - ' ? undefined : filter?.intervalo,
        custo: filter?.custo?.value,
        tipo: filter?.tipo?.value,
        talhoes: filter?.talhoes?.map((item) => item.id),
        safra: filter?.safra,
        parametroconta: filter?.parametroconta?.id,
      };

      const response = await api.relTalhoes().getTalhoesProducao(newFilters);
      setRelTalhaoProducao(response);
      setRelTalhaoProducaoLoading(false);
    } catch (errors) {
      setRelTalhaoProducaoLoading(false);
    }
  }, []);

  const [relTalhoesIndiretos, setRelTalhoesIndiretos] = useState({});
  const [relTalhoesIndiretosLoading, setRelTalhoesIndiretosLoading] =
    useState(false);

  const getRelTalhoesIndiretos = useCallback(async (filter) => {
    try {
      setRelTalhoesIndiretosLoading(true);

      const response = await api.relTalhoes().getRelTalhoesIndiretos(filter);
      setRelTalhoesIndiretos(response);
    } finally {
      setRelTalhoesIndiretosLoading(false);
    }
  }, []);

  // Usando useMemo para evitar a recriação do contexto em cada renderização
  const value = useMemo(
    () => ({
      getTalhoesProducao,
      relTalhaoProducao,
      relTalhaoProducaoLoading,
      getRelTalhoesIndiretos,
      relTalhoesIndiretos,
      relTalhoesIndiretosLoading,
    }),
    [
      getTalhoesProducao,
      relTalhaoProducao,
      relTalhaoProducaoLoading,
      getRelTalhoesIndiretos,
      relTalhoesIndiretos,
      relTalhoesIndiretosLoading,
    ],
  );

  return (
    <RelTalhaoContext.Provider value={value}>
      {children}
    </RelTalhaoContext.Provider>
  );
}

export function useRelTalhao() {
  const context = React.useContext(RelTalhaoContext);

  if (!context)
    throw new Error('useRelTalhao must be used within a RelTalhaoProvider');

  return context;
}
